import { AuthMockApi } from 'app/mock-api/common/auth/api';
import { NavigationMockApi } from 'app/mock-api/common/navigation/api';
import {DeviceMockApi} from "./recycling/devices/api";
import {RecyclerLocationsMockApi} from "./recycling/recycler-locations/api";
import {RecyclersMockApi} from "./recycling/recyclers/api";

export const mockApiServices = [
    AuthMockApi,
    DeviceMockApi,
    RecyclerLocationsMockApi,
    RecyclersMockApi,
    NavigationMockApi,
];
